import type { TOC } from '@ember/component/template-only';
import { eq, or } from 'ember-truth-helpers';
import { local } from 'embroider-css-modules';

import type { BadgeType } from '../../types/components/prism/badge.ts';
import type { IconName } from '../../types/components/prism/icon.ts';
import styles from './badge.module.css';
import PrismIcon from './icon.gts';

interface PrismBadgeSignature {
  Args: {
    /**
     * @deprecated Will be renamed to type.
     */
    badgeType?: BadgeType;
    iconName?: IconName;
    /**
     * @deprecated Icon will always be shown on the left.
     */
    iconPosition?: 'left' | 'right';
    /**
     * @deprecated Will be renamed to isSmall.
     */
    isSmallBadge?: boolean;
    label?: number | string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const PrismBadge: TOC<PrismBadgeSignature> = <template>
  <div
    class={{local
      styles
      "prism-badge"
      (or @badgeType "neutral")
      (if @isSmallBadge "is-small")
    }}
    data-test-badge={{if (eq @label undefined) "" @label}}
    ...attributes
  >
    {{#if (eq @iconPosition "left")}}
      {{#if @iconName}}
        <PrismIcon @color="inherit" @name={{@iconName}} @size="small" />
      {{/if}}
    {{/if}}

    {{#if (eq @label undefined)}}
      {{yield}}
    {{else}}
      {{@label}}
    {{/if}}

    {{#if (eq @iconPosition "right")}}
      {{#if @iconName}}
        <PrismIcon @color="inherit" @name={{@iconName}} @size="small" />
      {{/if}}
    {{/if}}
  </div>
</template>;

export default PrismBadge;

export type { BadgeType };
